module.exports = __webpack_public_path__ + "static/media/might.c9ab91f5.png";